export default function ApplicationLogo(props) {
    return (
        <img src="/img/logo-dark.png" alt="Logo" className='h-12 w-auto' />
    );
}
